<!--
// app/pages/[region]/players-legend.vue
-->
<script setup lang="ts">
import type { PlayerSeasons } from "#shared/player/domain/Player";
import HeaderBannerTitle from "~/components/Shared/HeaderBannerTitle.vue";
import CardLegendPlayer from "~/components/pages/legends/CardLegendPlayer.vue";
import { useWebContext } from "~/composables/webContext";
import { useCompetitionStore } from "~/stores/competitionStore";
import { usePlayers } from "~/composables/players";
import { $LEGEND_PLAYER_IDS } from "#shared/player/domain/services/playerService";

definePageMeta({
  i18n: {
    paths: {
      en: "/legends",
      es: "/leyendas",
      de: "/legenden",
      fr: "/legendes",
      it: "/leggende",
      pt: "/lendas",
    },
  },
  middleware: ["not-found-queens"],
  layout: "team-and-player",
});

const { t } = useI18n();
const router = useRouter();
const { webContext, contextSiteTitle } = useWebContext();
const { region, currentSeason } = useCompetitionStore();

const playerLegends: number[] = $LEGEND_PLAYER_IDS || [];

const { useFetchParamsPlayerSeasons } = usePlayers();

const itemList: string[] = [];
for (let i = 0; i < playerLegends.length; i++) {
  const fetchPlayerOpts = useFetchParamsPlayerSeasons(playerLegends[i]);
  const { data } = await useFetch(fetchPlayerOpts);
  const playerData: PlayerSeasons | undefined = data.value ? data.value : undefined;
  if (playerData) {
    itemList.push(
      `{"@type": "ListItem","position": "${i + 1}","item": {"@type" : "Person","name" : "${playerData?.shortName}"}}`
    );
  }
}

useSeoMeta({
  title: t("header.navCompetition.legends"),
  ogTitle: t("header.navCompetition.legends"),
  description: t("meta.description.legendPlayers.page", { league: contextSiteTitle }),
  ogDescription: t("meta.description.legendPlayers.page", { league: contextSiteTitle }),
});

useHead({
  script: () => [
    {
      type: "application/ld+json",
      innerHTML: `{"@context": "https://schema.org","@type": "ItemList", "itemListElement": [${itemList}]}`,
    },
  ],
});
</script>

<template>
  <header-banner-title :title="$t('legends.banner.title')" />

  <section class="px-4 py-6 lg:py-16">
    <div
      class="kql-w-container grid grid-cols-1 justify-items-center sm:grid-cols-[repeat(1,336px)] md:grid-cols-[repeat(2,336px)] lg:grid-cols-[repeat(3,336px)] xl:grid-cols-[repeat(4,336px)] gap-4 justify-center"
    >
      <card-legend-player
        v-for="(playerId, i) in playerLegends"
        :key="i"
        :player-id="playerId"
        :preload="i === 0"
      />
    </div>
  </section>
</template>

<style scoped></style>
